import { render, staticRenderFns } from "./balance-detail.vue?vue&type=template&id=fa8fc942&"
import script from "./balance-detail.vue?vue&type=script&lang=js&"
export * from "./balance-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports